// Activity kinds whose scorecard drawer shows a contextual left pane (resume /
// contact for reviews, submission details for assessments). Interviews keep
// their transcript pane inside CollectScoreCardDrawerV1, so they are excluded.
export const REVIEW_KINDS = ['review'];

export const ASSESSMENT_KINDS = [
  'assessment',
  'hackerrank',
  'hackerearth_assessment',
  'criteriacorp_assessment',
  'codeinterview_assessment',
];

export const isContextualScorecardKind = (kind?: string): boolean =>
  !!kind && (REVIEW_KINDS.includes(kind) || ASSESSMENT_KINDS.includes(kind));
